import React from "react";

export default function PrimaryBtn({ text }) {
  return <button className="book_btn see_more">{text}</button>;
}
